import { render } from "./OfertaCursos.vue?vue&type=template&id=7ca5ff6c&scoped=true"
import script from "./OfertaCursos.vue?vue&type=script&lang=js"
export * from "./OfertaCursos.vue?vue&type=script&lang=js"

import "./OfertaCursos.vue?vue&type=style&index=0&id=7ca5ff6c&scoped=true&lang=css"

import exportComponent from "D:\\WEB\\LICEO\\CURSOS\\portalalumnoscursos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ca5ff6c"]])

export default __exports__